export default __webpack_public_path__ + "alberta-operating-hours.9277f0c2b9cf9b32f62e.svg";